import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA,MatDialogActions } from '@angular/material/dialog';

@Component({
  selector: 'app-clearance-check-dialog',
  standalone: true,
  imports: [MatDialogActions],
  templateUrl: './clearance-check-dialog.component.html',
  styleUrl: './clearance-check-dialog.component.scss'
})
export class ClearanceCheckDialogComponent {
  constructor(private dialogRef: MatDialogRef<ClearanceCheckDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) {}

  onSuccessResponse() {
    this.dialogRef.close(true); 
    
  }

  onNegativeResponse() {
    this.dialogRef.close();
  }
}
